<div class="profile-container {{className}}" [ngStyle]="{'background-color': backgroundColor}">
  <div *ngIf="shouldShown('avatar') && picUrl">
    <span class="avatar" [ngStyle]="{'background-image':'url(' + picUrl + ')'}"></span>
  </div>
  <span class="name" *ngIf="shouldShown('name')">{{name}}</span>
  <span class="date" *ngIf="shouldShown('date')">{{date}}</span>
  <span class="initials" *ngIf="shouldShown('initials')">{{name}}</span>
</div>
